var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHello(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 130,
    viewBox: "0 0 164 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 84.5,
    r: 42.5,
    fill: "#F0ECF5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.4268,
    cy: 74,
    r: 11.25,
    stroke: "#13100D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4268 81C66.4268 82.6667 60.096 87.9505 57.9269 95C55.9268 101.5 57.4267 105.5 59.9267 105.5C62.4267 105.5 63.2127 103 63.4269 101.5C64.0697 97 66.4267 93 68.9267 93",
    stroke: "#13100D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4267 77.5C91.4267 77.5 92.9268 76 95.4268 73.5C97.5481 71.3787 99.6359 68.8546 101.927 70C103.927 71 102.979 74.7881 100.427 77.5C92.4267 86 90.812 89.7828 89.9267 91C85.9267 97.5 86.4267 101.5 88.4267 106",
    stroke: "#13100D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4268 78C74.9268 80 80.3268 81.6 83.9268 78",
    stroke: "#13100D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4268 71.3908C73.0823 70.8763 74.947 70.0991 77.1617 71.1066",
    stroke: "#13100D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1819 71.3908C84.5264 70.8763 82.6617 70.0991 80.447 71.1066",
    stroke: "#13100D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M163.5 56C163.5 63.4395 157.249 69.5 149.5 69.5C141.751 69.5 135.5 63.4395 135.5 56C135.5 48.5605 141.751 42.5 149.5 42.5C157.249 42.5 163.5 48.5605 163.5 56Z",
    stroke: "#C0B7D1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 10.5,
    r: 10,
    stroke: "#FFEAD7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 48,
    r: 6,
    fill: "#FFEAD7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 97.5,
    r: 4.5,
    fill: "#FFEAD7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141,
    cy: 117.5,
    rx: 4,
    ry: 4.5,
    fill: "#F0ECF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 130,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 114,
    fill: "white",
    transform: "translate(21 27)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHello);
export default __webpack_public_path__ + "static/media/hello.f1d0842c88e4c09845d5f7e4f64d4073.svg";
export { ForwardRef as ReactComponent };